import React, { useState } from 'react';
import SectionTitle from './common/SectionTitle';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaLinkedin, FaTwitter, FaInstagram, FaFacebook, FaCheckCircle } from 'react-icons/fa';
import { demoService } from '../services/apiClient';

const Contact = () => {
  const [formData, setFormData] = useState({
    to:'hello@sellwise360.com',
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [errors, setErrors] = useState({});
  // Validation regex patterns
  const phoneRegex = /^[\d\s+.,]+$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validateForm = () => {
    const newErrors = {};

    // Email validation
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    // Phone validation (if provided)
    if (formData.phone && !phoneRegex.test(formData.phone)) {
      newErrors.phone = 'Phone number can only contain numbers, +, ., , and spaces';
    }

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }

    // Message validation
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      await demoService.submitContactForm(formData);
      setIsSubmitted(true);
      setFormData({
        to:'hello@sellwise360.com',
        name: '',
        email: '',
        phone: '',
        company: '',
        message: ''
      });
      setErrors({});
    } catch (err) {
      setErrors({ submit: err instanceof Error ? err.message : 'An error occurred while sending your message' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="contact" id="contact">
      <br/><br/>
      <div className="container">
        <SectionTitle
          title="Contact Us"
          subtitle="Get in touch to learn how SellWise360 can help your distribution business"
        />
        <div className="contact-container">
          <div className="contact-info">
            <h3>Let's Talk About Your Needs</h3>
            <div className="contact-details">
              <div className="contact-detail">
                <div className="contact-icon">
                  <FaMapMarkerAlt />
                </div>
                <p>Barometergatan 35, 41841, Sweden<br/>
                6 Lateef Salami Street, Ajao Estate, Lagos, Nigeria</p>
              </div>
              <div className="contact-detail">
                <div className="contact-icon">
                  <FaPhone />
                </div>
                <p>+46-769702095<br/>+234-8133694347</p>
              </div>
              <div className="contact-detail">
                <div className="contact-icon">
                  <FaEnvelope />
                </div>
                <p>hello@sellwise360.com</p>
              </div>
            </div>
            <div className="social-links">
              <a href="https://www.facebook.com/profile.php?id=61579591531789" className="social-link"><FaFacebook /></a>
              <a href="#" className="social-link"><FaLinkedin /></a>
              <a href="https://x.com/SellWise360" className="social-link"><FaTwitter /></a>
              <a href="https://www.instagram.com/sellwise360" className="social-link"><FaInstagram /></a>
            </div>
          </div>
          
           <div className="contact-form">
            {isSubmitted ? (
              <div className="success-message">
                <div className="success-icon">
                  <FaCheckCircle />
                </div>
                <h3>Message Sent!</h3>
                <p>Thank you for contacting us. We'll get back to you within 24 hours.</p>
                <button
                  onClick={() => setIsSubmitted(false)}
                  className="cta-button"
                >
                  Send Another Message
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                {errors.submit && (
                  <div className="error-message">
                    {errors.submit}
                  </div>
                )}
                
                <div className="form-group">
                  <input 
                    type="text" 
                    name="name"
                    placeholder="Your Name *" 
                    required 
                    value={formData.name}
                    onChange={handleChange}
                    className={errors.name ? 'error' : ''}
                  />
                  {errors.name && <span className="error-text">{errors.name}</span>}
                </div>

                <div className="form-group">
                  <input 
                    type="email" 
                    name="email"
                    placeholder="Your Email *" 
                    required 
                    value={formData.email}
                    onChange={handleChange}
                    className={errors.email ? 'error' : ''}
                  />
                  {errors.email && <span className="error-text">{errors.email}</span>}
                </div>

                <div className="form-group">
                  <input 
                    type="text" 
                    name="company"
                    placeholder="Company Name" 
                    value={formData.company}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <input 
                    type="tel" 
                    name="phone"
                    placeholder="Phone Number" 
                    value={formData.phone}
                    onChange={handleChange}
                    className={errors.phone ? 'error' : ''}
                  />
                  {errors.phone && <span className="error-text">{errors.phone}</span>}
                </div>

                <div className="form-group">
                  <textarea 
                    name="message"
                    placeholder="How can we help you? *" 
                    required 
                    value={formData.message}
                    onChange={handleChange}
                    className={errors.message ? 'error' : ''}
                  ></textarea>
                  {errors.message && <span className="error-text">{errors.message}</span>}
                </div>

                <button 
                  type="submit" 
                  className="cta-button"
                  disabled={isLoading}
                >
                  {isLoading ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
      <br /><br />
    </section>
  );
};

export default Contact;